import sectionSizingChartHurryBoxCss from '../css-snippets/section-sizing-chart-hurry-box';

const html = `
<style>${sectionSizingChartHurryBoxCss}</style>
<div
  id="card-container-unique-id"
  data-id="unique-id"
  data-attribute="card-container"
  data-background="#FFFFFF"
  data-top-padding="true"
  data-bottom-padding="true"
  style="background-color: rgb(255, 255, 255)"
>
  <div
    class="container-page"
    data-attribute="container-page"
    data-show-style="false"
    data-background="#FFFFFF"
    style="background-color: transparent"
  >
    <div class="wrap-card">
      <div data-attribute="card-accordions">
        <div data-attribute="card-accordion" class="wrap-accordion">
          <div data-attribute="accordion-title" class="accordion-title">
            <div data-attribute="accordion-title-text">Sizing Chart</div>
            <div class="accordion-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-chevron-down-icon lucide-chevron-down"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </div>
          </div>
          <div data-attribute="accordion-content" class="accordion-content">
            <div class="wrap-content">
              <div
                data-attribute="wrap-image"
                class="wrap-img"
                data-show-image="true"
                style="display: block"
              >
                <img
                  loading="lazy"
                  data-attribute="image-content"
                  src="https://cdn.skyfastimg.com/images/2025/10/27/image-68ff3d7dd4c704ee388cd8b4.webp?w=600&h=50&q=80"
                  alt=""
                />
              </div>
              <div data-attribute="accordion-text" class="accordion-text">
                <p style="text-align: center">
                  <span
                    ><strong>*Size down for STRONGER compression*</strong></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

`;

export default html;
